import addReadWriteRecipients from './addReadWriteRecipients';
import datapoints from '../datapoints';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import { logUsage } from 'owa-analytics';
import addFindPeopleEntityFromResults from 'owa-recipient-common/lib/utils/addFindPeopleEntityFromResults';
import { action } from 'satcheljs/lib/legacy';

export default action('addHighlightedFindRecipient')(function addHighlightedFindRecipient(
    recipientWell: RecipientWellWithFindControlViewState
) {
    // Only add highlighted recipient when find result is visible
    if (recipientWell.shouldShowFindResult) {
        const { name: eventName, customData: customData } = datapoints.AddRecipientFromFindControl;
        logUsage(
            eventName,
            customData(recipientWell.findResultHightlightIndex, recipientWell.findResultType)
        );

        let highlightedFindRecipient =
            recipientWell.findResultSet[recipientWell.findResultHightlightIndex];

        addFindPeopleEntityFromResults(
            recipientWell,
            highlightedFindRecipient,
            recipientWell.findResultHightlightIndex
        );
        addReadWriteRecipients(recipientWell, [
            { isValid: true, newPersona: highlightedFindRecipient, newEmailAddress: null },
        ]);
    }
});
